import * as React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import "bootstrap/dist/css/bootstrap.min.css";
import View from "./components/View";
import AdminDashboard from "./components/AdminDashboard";
import OperationalReport from "./components/OperationalReport";
import SuperAdmin from "./components/SuperAdmin";
import MyCart from "./components/MyCart";
import ThankYouComponent from "./components/ThankYou";
import MultipleWarrantiesThankYou from "./components/MultipleWarrantiesThankYou";
import { GafOktaManager } from "./auth/gaf-okta-auth";
import { addSessionBeforeUnload, removeSessionBeforeUnload } from "./utils/utils";
//Okta pages
import { Home } from "./components/home";
import { HomeLoggedIn } from "./components/home-logged-in";
import { HomeNotLoggedIn } from "./components/home-not-logged-in";
import { Callback } from "./components/callback";
import * as CONFIG from "../config.json";
import Layout from "./components/Layout";
import "./App.scss";

const history = createBrowserHistory();

class Routes extends React.Component<{}, {}, {}> {
    state = {
        authenticated: false,
    };

    constructor(props: any) {
        super(props);
    }
    componentWillMount() {
        addSessionBeforeUnload();
        const authenticated = GafOktaManager.isAuthenticated;
        if (authenticated) {
            localStorage.removeItem("skipSessionClear");
        }
        this.setState({ authenticated });
    }
    render() {
        return (
            <Router>
                {this.state.authenticated ? (
                    <div className="p-0 container-fluid">
                        <Layout>
                            <Route exact path="/" component={AdminDashboard} />
                            <Route exact path="/operationalreport" component={OperationalReport} />
                            <Route exact path="/superadmin" component={SuperAdmin} />
                            <Route exact path="/myCart" component={MyCart} />
                            <Route exact path="/paymentsuccess" component={MultipleWarrantiesThankYou} />
                            <Route exact path="/resubmitpaymentsuccess" component={ThankYouComponent} />
                            <Route exact path="/paymenterror" component={ThankYouComponent} />
                            <Route exact path="/paymentcancel" component={ThankYouComponent} />
                        </Layout>
                    </div>
                ) : (
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route exact path="/operationalreport" component={Home} />
                        <Route exact path="/superadmin" component={Home} />
                        <Route exact path="/myCart" component={Home} />
                        <Route exact path="/paymentsuccess" component={Home} />
                        <Route exact path="/resubmitpaymentsuccess" component={Home} />
                        <Route exact path="/paymenterror" component={Home} />
                        <Route exact path="/paymentcancel" component={Home} />
                        <Route exact path="/callback" component={Callback} />
                        <Route exact path="/homenotloggedin" component={HomeNotLoggedIn} />
                        <Route exact path="/homeloggedin" component={HomeLoggedIn} />
                    </Switch>
                )}
            </Router>
        );
    }
}

export default Routes;
